import { merge } from 'lodash';
import React, { useContext } from 'react';
import {
  DetailToolbarBtnName,
  EmptyComponent,
  EvidenceProps,
  FormPanel,
  UserContext,
  getItemFactory,
} from '@eas/common-web';
import { useDatedEvidence } from '@composite/evidence/dated-evidence';
import { Loan } from '@models';
import { EntityName, EvidenceApiUrl, Role } from '@enums';
import { ActionBar } from './loan-actionbar';
import { createLoan } from './loan-api';
import { useLoanFields } from './loan-fields';
import { useValidationSchema } from './loan-schema';

function Fields() {
  const LoanFields = useLoanFields();
  return (
    <FormPanel label="Zápůjčka">
      <LoanFields />
    </FormPanel>
  );
}

export function useLoans({
  evidenceProps,
}: {
  evidenceProps?: Partial<EvidenceProps<Loan>>;
}) {
  const validationSchema = useValidationSchema();
  const columns = evidenceProps?.tableProps?.columns ?? [];
  const props = merge(
    {
      identifier: 'LOANS',
      apiProps: {
        url: EvidenceApiUrl.LOAN,
        getItem: getItemFactory(),
        createItem: (_api: string, item: Loan) =>
          createLoan({
            loanedFile: item.loanedFile,
            borrower: item.borrower,
            relatedFile: item.relatedFile,
          }),
      },
      tableProps: {
        columns,
        tableName: 'Zápůjčky',
        defaultSorts: [{ field: 'loanedOn', type: 'FIELD', order: 'DESC' }],
        showReportButton: false,
        showBulkActionButton: false,
      },
      detailProps: {
        entityName: EntityName.LOAN,
        FieldsComponent: Fields,
        GeneralFieldsComponent: EmptyComponent,
        validationSchema,
        toolbarProps: { title: 'Zápůjčka', showBtn: showBtn(), ActionBar },
      },
    },
    evidenceProps
  );
  return { evidenceBag: useDatedEvidence<Loan>(props) };
}

function showBtn() {
  return function useShowBtn(button: DetailToolbarBtnName) {
    const { hasPermission } = useContext(UserContext);
    if (button === 'NEW') {
      return hasPermission(Role.FILE_ROOM) || hasPermission(Role.SUPERADMIN);
    }
    return ['CHECK', 'SAVE', 'CLOSE', 'REFRESH', 'SHARE'].includes(button);
  };
}
